/**
 * Article Page Meta Information
 * -----------------------------------------------------------------------------
 *
 * Currently, the following code is applied to the Article Meta partial of the
 * Story Page and Article templates; which is a series of elements below the
 * page title.
 *
 * Article meta provides the user with:
 *
 * 1. Author Name
 * 2. Publish Date
 * 3. Share on X
 * 4. Share on Facebook
 * 4. Share on LinkedIn
 * 5. Copy page URL
 * 6. Share page via Email
 */

// Imports
const $               = require( 'jquery' );
const copyToClipboard = require( '../utilities/_copy-to-clipboard' );
const Snackbar        = require( '../components/snackbar' );



// Variables
const $shareActions = $( '.article-meta__actions' );



if ( $shareActions.length ) {

  const pageUrl        = window.location.href;
  const pageUrlEncoded = encodeURIComponent( pageUrl );

  const popupSettings = 'popup=yes,width=800,height=600';

  const subjectText = 'Check out this link';
  const bodyText    = `Check out this link: ${ pageUrl }`;
  const mailtoLink  = `mailto:?subject=${ encodeURIComponent( subjectText ) }&body=${ encodeURIComponent( bodyText ) }`;

  /**
   * Open a new window (browsing context).
   * 
   * @param {String} url      URL of page to open.
   * @param {String} target   Browsing context. For this feature, should be
   *                          different for each item.
   * @param {String} settings New window features, i.e. `width`, `height`, etc.
   */
  const createPopup = function createPopup( url, target, settings = popupSettings ) {

    const popup = window.open( url, target, settings );

    if ( popup ) {
      popup.focus(); // Ensure focus is on the new window.
    } else {
      alert( 'Please allow pop-ups for this site.' );
    }

  }



  /**
   * Share on X.
   *
   * @param {Event} e The browser event.
   */
  $( '.article-meta__link--x-share' ).on( 'click', function ( e ) {

    createPopup(
      `https://twitter.com/intent/tweet?url=${ pageUrlEncoded }&utm_source=x&utm_medium=social`,
      'xShareTab'
    );

  } );



  /**
   * Share on Facebook.
   *
   * @param {Event} e The browser event.
   */
  $( '.article-meta__link--facebook-share' ).on( 'click', function ( e ) {

    createPopup(
      `https://www.facebook.com/sharer/sharer.php?u=${ pageUrlEncoded }&utm_source=facebook&utm_medium=social`,
      'facebookShareTab'
    );

  } );



  /**
   * Share on LinkedIn.
   *
   * @param {Event} e The browser event.
   */
  $( '.article-meta__link--linkedin-share' ).on( 'click', function ( e ) {

    createPopup(
      `https://www.linkedin.com/sharing/share-offsite/?url=${ pageUrlEncoded }&utm_source=linkedin&utm_medium=social`,
      'linkedinShareTab'
    );

  } );



  /**
   * Copy current page URL to the Clipboard.
   *
   * Show user a snackbar/toast notification on success.
   *
   * @param {Event} e The browser event.
   */
  $( '.article-meta__link--copy-url' ).on( 'click', function ( e ) {

    copyToClipboard(
      `${ pageUrl }?utm_source=copylink&utm_medium=referral&utm_content=blogpost`,
      () => {
        Snackbar( { message: 'Copied to Clipboard' } )
      },
      () => {
        console.warn( 'Error: Unable to copy to Clipboard.' )
      }
    );

  } );



  /**
   * Share page via Email.
   */
  $( '.article-meta__link--email-page' ).attr( 'href', mailtoLink );


} // if ( $shareActions.length )